module.exports = __webpack_public_path__ + "img/spec_detail_en.8f0068c0.jpg";